<template>
  <div>
    <cloud-imgs

        v-if="utils.string.vNotEmpty(url)"
        :border-radius="borderRadius"
        :click-view="clickView"
        ref="clouds"
        @item-delete="$emit('item-delete')"
        :img-width="imgWidth"
        :img-height="imgHeight"
        :show-del-btn="showDelBtn"
        :imgs="[{ url: url }]"></cloud-imgs>
  </div>
</template>

<script>

import CloudImgs from "@/components/base/layout/img/CloudImgs.vue";
import {utils} from "@/util/utils";

export default {
  computed: {
    utils() {
      return utils
    }
  },
  components: {CloudImgs},
  props: {
    url: {
      type: String
    },
    showDelBtn: {
      type: Boolean,
      default: false,
    },
    imgWidth: {
      type: Number,
      default: 100,
    },
    imgHeight: {
      type: Number,
      default: 100,
    },
    clickView: {
      type: Boolean,
      default: true
    },
    borderRadius: {
      type: Number,
      default: 0
    },
  },
  name: "CloudImg",
};
</script>
